import { makeAutoObservable, observable, runInAction } from 'mobx';
import { SettingsBranches } from '../api/types/settings/branches/settings-branches';
import { SettingsBuilding } from '../api/types/settings/branches/buildings/settings-building';
import { SettingsClassesAttributeEntity } from '../api/types/settings/class-attributes/settings-class-attributes';
import { ClassMetadata } from '../api/types/settings/branches/buildings/classes/class-metadata';
import { WorkingYearsManagement } from '../api/types/settings/working-time-management/working-time-management';
import { BuildingResponseWithClassesAttributes } from '../api/types/settings/buildings/building';
import { ClassAttributeList } from '../api/types/settings/settings-all';

class GlobalSettingsBranches {
  get currentBuildingIndex(): number | null {
    return this._currentBuildingIndex;
  }

  set currentBuildingIndex(value: number | null) {
    this._currentBuildingIndex = value;
  }

  private _workingTimeManagement: WorkingYearsManagement | undefined;
  private _branches: SettingsBranches[] = [];
  private _buildings: BuildingResponseWithClassesAttributes[] = [];
  private _classAttributes: SettingsClassesAttributeEntity[] = [];
  private _classAttributes2: ClassAttributeList[] = [];

  private _currentBranchIndex: number | null = null;

  private _currentBuildingIndex: number | null = null;

  private _currentClassIndex: number | null = null;

  private _breadCrumbs: string[] = [`שלוחות`];
  private _currentIndex = 0;

  constructor() {
    //makeAutoObservable(this);
    //makeAutoObservable(this, {}, { deep: true }); // Just add deep: true
    makeAutoObservable(this, {}, { deep: true });

    // TODO delete this api call
    this._branches = [];
  }

  handleNavigationToBuildingOperation = (branchIndex: number | null) => {
    console.log(`$$$$$$$$$$$ 11`);

    if (
      branchIndex !== null &&
      branchIndex < globalSettingsBranches.branches.length
    ) {
      globalSettingsBranches.currentBranchIndex = branchIndex;
      this._breadCrumbs = [
        `שלוחות (${this._branches[branchIndex].branchName})`,
        `מבנים`,
      ];

      this.currentIndex = 1;
      this._currentBuildingIndex = null;
    } else if (
      this._currentBranchIndex !== null &&
      this._branches[this._currentBranchIndex]
    ) {
      this._breadCrumbs = [
        `שלוחות (${this._branches[this._currentBranchIndex].branchName})`,
        `מבנים`,
      ];
      this.currentIndex = 1;
      this._currentBuildingIndex = null;
    }
  };
  handleNavigationToClasses = (buildingIndex: number) => {
    if (
      this._currentBranchIndex !== null &&
      this._currentBranchIndex !== null
    ) {
      const currentBranch = this.branches[this.currentBranchIndex!];
      if (currentBranch) {
        const currentBuilding = currentBranch.buildings[buildingIndex];
        if (currentBuilding) {
          this._currentBuildingIndex = buildingIndex;
          this._breadCrumbs = [
            `שלוחות (${this._branches[this._currentBranchIndex].branchName})`,
            'מבנים ' +
              `(${this._branches[this._currentBranchIndex].buildings[this._currentBuildingIndex].buildingName}) `,
            `כיתות`,
          ];
          this.currentIndex = 2;
        }
      }
    }
  };

  handleNavigationToClassesAttributes = (classIndex: number) => {
    if (
      this._currentBranchIndex !== null &&
      this._currentBuildingIndex != null
    ) {
      const currentBranch = this.branches[this.currentBranchIndex!];
      const currentBuilding =
        currentBranch.buildings[this._currentBuildingIndex];

      if (currentBuilding && classIndex < currentBuilding.classes.length) {
        this._currentClassIndex = classIndex;
        this.currentIndex = 3;
      }
    }
  };

  handleNavigationToBranches = () => {
    runInAction(() => {
      this.currentBranchIndex = null;
      this._currentBuildingIndex = null;
      this.currentIndex = 0;
      this._breadCrumbs = [`שלוחות`];
    });
  };

  getCurrentBranch() {
    if (
      this._currentBranchIndex !== null &&
      this._currentBranchIndex < this._branches.length
    ) {
      return this._branches[this._currentBranchIndex];
    }
    return;
  }

  getCurrentBuilding(): SettingsBuilding | null {
    if (
      this.getCurrentBranch() &&
      this._currentBuildingIndex !== null &&
      this._currentBuildingIndex < this.getCurrentBranch()!.buildings.length
    ) {
      return this.getCurrentBranch()!.buildings![this._currentBuildingIndex];
    }
    return null;
  }

  getCurrentClass(): ClassMetadata | null {
    const currentBuilding = this.getCurrentBuilding();

    if (currentBuilding && this._currentClassIndex !== null) {
      return currentBuilding.classes[this._currentClassIndex];
    }

    return null;
  }

  get workingTimeManagement(): WorkingYearsManagement | undefined {
    return this._workingTimeManagement;
  }

  set workingTimeManagement(value: WorkingYearsManagement | undefined) {
    this._workingTimeManagement = value;
  }

  get classAttributes(): SettingsClassesAttributeEntity[] {
    return this._classAttributes;
  }

  set classAttributes(value: SettingsClassesAttributeEntity[]) {
    this._classAttributes = value;
  }

  get classAttributes2(): ClassAttributeList[] {
    return this._classAttributes2;
  }

  set classAttributes2(value: ClassAttributeList[]) {
    this._classAttributes2 = value;
  }

  get branches(): SettingsBranches[] {
    return this._branches;
  }

  set branches(value: SettingsBranches[]) {
    this._branches = value;
  }

  get buildings(): BuildingResponseWithClassesAttributes[] {
    return this._buildings;
  }

  set buildings(
    value: BuildingResponseWithClassesAttributes[],
  ): BuildingResponseWithClassesAttributes[] {
    return (this._buildings = value);
  }

  get currentBranchIndex(): number | null {
    return this._currentBranchIndex;
  }

  set currentBranchIndex(value: number | null) {
    this._currentBranchIndex = value;
  }

  get breadCrumbs(): string[] {
    return this._breadCrumbs;
  }

  set breadCrumbs(value: string[]) {
    this._breadCrumbs = value;
  }

  get currentIndex(): number {
    return this._currentIndex;
  }

  set currentIndex(value: number) {
    this._currentIndex = value;
  }

  addClassToCurrentBuilding = (newClass: ClassMetadata) => {
    this.getCurrentBuilding()?.classes.push(newClass);
  };
}
const globalSettingsBranches = new GlobalSettingsBranches();
export default globalSettingsBranches;
